module.exports = __webpack_public_path__ + "img/sms-icon.237923b3.svg";